import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "../../utils/axiosConfig";
import "../../styles/features/questionary/RegistrationSurvey.css";

export default function RegistrationSurvey({
  interestId,
  onFinished,
}) {
  const { getAccessTokenSilently } = useAuth0();

  const [form, setForm] = useState({
    motivation: "",
    beenBefore: "",
    preferredTimes: [],
  });

  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();

    try {
      setSubmitting(true);

      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: "https://someet-api",
        },
      });

      await axios.patch(
        `/api/event-interests/${interestId}/survey`,
        {
          motivation: form.motivation || null,
          beenBefore:
            form.beenBefore === ""
              ? null
              : form.beenBefore === "YES",
          preferredTime: form.preferredTime || null,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  

      setMessage("Dzięki za odpowiedzi ❤️");

      setTimeout(() => {
        onFinished();
      }, 1200);
    } catch (err) {
      setMessage(
        err.response?.data?.message ||
          "Nie udało się zapisać odpowiedzi."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="registrationSurvey">
      <h3>Gotowe! Jesteś na liście! 💛<br/>Gdy zbierzemy odpowiednią grupę, odezwiemy się do Ciebie z propozycją terminu.
        <br/></h3>
      <p>
        Jeśli masz ochotę, odpowiedz na kilka krótkich pytań.
        Pomoże nam to lepiej organizować kolejne spotkania.
      </p>

      <form onSubmit={submit}>
        <fieldset>
          <legend>
            Co najbardziej zachęciło Cię do zapisu?
          </legend>

          {[
            ["MEET_NEW_PEOPLE", "Chcę poznać nowych znajomych"],
            ["LOOKING_FOR_RELATIONSHIP", "Szukam relacji"],
            ["HAVE_A_NICE_TIME", "Chcę po prostu miło spędzić czas"],
            ["NEW_IN_CITY", "Dopiero co przeprowadziłem/am się do miasta"],
            ["OTHER", "Inny powód"],
          ].map(([value, label]) => (
            <label key={value}>
              <input
                type="radio"
                name="motivation"
                value={value}
                checked={form.motivation === value}
                onChange={(e) =>
                  setForm({
                    ...form,
                    motivation: e.target.value,
                  })
                }
              />
              {label}
            </label>
          ))}
        </fieldset>

        <fieldset>
          <legend>
            Czy byłeś/aś już kiedyś na takim spotkaniu?
          </legend>

          <label>
            <input
              type="radio"
              name="beenBefore"
              value="YES"
              checked={form.beenBefore === "YES"}
              onChange={(e) =>
                setForm({
                  ...form,
                  beenBefore: e.target.value,
                })
              }
            />
            Tak
          </label>

          <label>
            <input
              type="radio"
              name="beenBefore"
              value="NO"
              checked={form.beenBefore === "NO"}
              onChange={(e) =>
                setForm({
                  ...form,
                  beenBefore: e.target.value,
                })
              }
            />
            Nie
          </label>
        </fieldset>

<fieldset>
  <legend>
    Jakie terminy najbardziej Ci odpowiadają?
  </legend>

  {[
    ["WEEKDAY_EVENING", "W tygodniu wieczorem"],
    ["FRIDAY_EVENING", "Piątek wieczorem"],
    ["WEEKEND", "Weekend"],
    ["ANY", "Bez znaczenia"],
  ].map(([value, label]) => (
    <label key={value}>
      <input
        type="checkbox"
        name="preferredTimes"
        value={value}
        checked={form.preferredTimes.includes(value)}
        onChange={(e) => {
          const checked = e.target.checked;

          setForm((prev) => ({
            ...prev,
            preferredTimes: checked
              ? [...prev.preferredTimes, value]
              : prev.preferredTimes.filter(
                  (item) => item !== value
                ),
          }));
        }}
      />
      {label}
    </label>
  ))}
</fieldset>

        {message && <p>{message}</p>}

        <div className="registrationSurvey__actions">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={submitting}
          >
            {submitting
              ? "Zapisywanie..."
              : "Wyślij odpowiedzi"}
          </button>

          <button
            type="button"
            className="btn btn-outline"
            onClick={onFinished}
          >
            Pomiń
          </button>
        </div>
      </form>
    </div>
  );
}